import MaskedObject from "../MaskedObject";
import { ObjectFit } from "../model/WideoDef";
import TextObject from "../TextObject";

export default class ScaleManager {

  public scaleObjectToFitMask = (object: MaskedObject) => {

    const otherObject = object.getOtherObject();
    const maskObject = object.getMaskObject();

    // Temporary unapply the mask to get the full size of the other object to be able to scale it to be equal to the
    // mask object.
    maskObject.unapply();

		// Calculate the x and y scale to fit the "other object" to the mask object
    console.debug("otherObject", otherObject.getLocalBounds().width, otherObject.getLocalBounds().height);
    console.debug("maskObject", maskObject.getLocalBounds().width, maskObject.getLocalBounds().height);
    const scaleX = (maskObject.getLocalBounds().width * maskObject.getAttributes().scaleX) / otherObject.getLocalBounds().width;
    const scaleY = (maskObject.getLocalBounds().height * maskObject.getAttributes().scaleY) / otherObject.getLocalBounds().height;
    const scale = this.objectFitScale(object.getReplaceObjectFit(), scaleX, scaleY);

		console.debug("object", object.getId());
		console.debug("scale", scale);

    // Re-apply the mask again 
    maskObject.apply();

		// Set the scale of the "other object" to fit the mask object
    otherObject.setAttributes({
      ...otherObject.getAttributes(), ...{
        x: 0,
        y: 0,
        scaleX: scale.scaleX,
        scaleY: scale.scaleY
      }
    });

  }

	public objectFitScale(objectFit: ObjectFit, scaleX: number, scaleY: number): { scaleX: number, scaleY: number } {
    let scale = 1;
    switch (objectFit) {
      case ObjectFit.Cover:
        scale = Math.max(Math.abs(scaleX), Math.abs(scaleY))
        return { scaleX: Math.sign(scaleX) * scale, scaleY: Math.sign(scaleY) * scale };

      case ObjectFit.None:
        scale = 1;
        return { scaleX: Math.sign(scaleX) * 1, scaleY: Math.sign(scaleY) * 1 };

      case ObjectFit.Fill:
        return { scaleX: Math.sign(scaleX) * scaleX, scaleY: Math.sign(scaleY) * scaleY }

      case ObjectFit.ScaleDown:
        scale = Math.min(Math.min(Math.abs(scaleX), Math.abs(scaleY)), 1);
        return { scaleX: Math.sign(scaleX) * scale, scaleY: Math.sign(scaleY) * scale };

      case ObjectFit.Contain: // Fall through intentional
      default:
        scale = Math.min(Math.abs(scaleX), Math.abs(scaleY));
        return { scaleX: Math.sign(scaleX) * scale, scaleY: Math.sign(scaleY) * scale };
    }
  }

	public fitTextToMask(object: TextObject) {
    console.debug("--- FIT: fitTextToMask", object.getText());
    console.debug("--- FIT: object.getHeight()", object.getHeight());
    console.debug("--- FIT: object.getText()", object.getText());
    let newHeight = object.measureTextHeight(object.getText());
    console.debug("--- FIT: newHeight", newHeight);
    // Repeat until the new height is "close" to the height of the original text object height
    // We see some instability with the algorithm, so we use a small epsilon allow small rounding errors (one hundredth of a pixel should not be visually noticeable).
    // measureTextHeight seems to be not always accurate, it returns slightly different values for the same text and font size between runs.
    // It might also be due to the fact that we get line breaks differently between runs (we are not handling this in this algorithm).
    let diff = newHeight - object.getHeight();
    console.debug("--- FIT: diff", diff);
    let x = 0;
    while (diff > 0 && x < 1000) {
      object.setFontSize(object.getFontSize() - 1); 
      newHeight = object.measureTextHeight(object.getText());
      console.debug("--- FIT: newHeight", newHeight);
      diff = newHeight - object.getHeight();
      console.debug("--- FIT: diff", diff);
      x++;
    }

  }


}